<template>
    <div>
        <template v-show="add_topup_payment !== null && add_topup_payment == true">
            <div  class="modal fade" id="needAttention" tabindex="-1" aria-labelledby="needAttention" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body fields-map-popup">
                            <div class="popup-head mb-4">
                                <h2 class="pb-0"> Need your attention. </h2>
                                <p> Please, add or map them all. </p>
                            </div>
                            <div class="need-attention-content">
                            </div>
                            <div class="mt-4 text-right">
                                <button type="button" class="btn btn-primary" id="popupProcessButton">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix" v-show="add_topup_payment == true">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left"> Topup Bulk Upload </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/topupsPayments"> Cancel </router-link>
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner" >
                        <div class="upload-sheet"  v-show="previewMapField == false">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Finja Business to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
                            </label>
                            <p> Download a sample template <a :href="`${$global.aws_base_url}/csv/TopupBulk.csv`">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="" id="drop" data-toggle="tooltip" data-placement="left"
                             title="<p class='align-left'>Your CSV file must have the following in order to upload employees in bulk: <br/>
							1. No repetitions of column names.<br/>
							2. Only add postpaid mobile numbers.<br/>
							3. Mobile numbers must be in the following format: 923XXXXXXXXX.<br/>
							4. No special characters in the sheet.<br/>
							5. Set the formatting of the mobile number column to 'number' with zero decimal places.<br/>
							6. There should be no empty cells in a valid row.<br/>
							7. Mobile Number, Network, Amount are required to upload a batch.</p>">
                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Finja Business to process your sheet."></i> </label>
                                    <div class="mandatory-tags">
                                        <div class="mandatory-fields-inner">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_mobile_number" id="mand_mobile_number" class="fas fa-check"></i> Mobile Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Network"> <i v-show="mand_network" id="mand_network" class="fas fa-check"></i> Network </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Amount"> <i v-show="mand_amount" id="mand_amount" class="fas fa-check"></i> Amount </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Type"> <i v-show="mand_type" id="mand_type" class="fas fa-check"></i> Type </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Type"> <i v-show="mand_name" id="mand_name" class="fas fa-check"></i> Name </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="add_topup_payment == null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="add_topup_payment == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                viewPage : true,
                previewMapField : false,
                mand_mobile_number : false,
                mand_amount : false,
                mand_network : false,
                mand_type : false,
                mand_name : false,
                previewMapField : false,
                fileAdded : false,
                filecolumn : [],
                fileRowData : [],
                dropZoneObject : null,
                proceedButtonflag : false,
                myurl:null,
                add_topup_payment:null,
            }
        },
        
        mounted(){
            
            let that = this;
            
            if(that.$route.query.topupId != null){
                that.myurl = that.$global.base_url+'api/postTopupBulkUpload?topupId='+that.$route.query.topupId;
            }else{
                that.myurl = that.$global.base_url+'api/postTopupBulkUpload';
            }
            this.initDropZone();
            $(".drozone-label").tooltip({
                html	: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
            });
            $("#drop").dropzone();  
            this.$Progress.start();
            this.can('add_topup_payment').then(result => {
                this.add_topup_payment = result.add_topup_payment;
                
            }).then(result => {
                this.$Progress.finish();
                $(window.document).on('show.bs.modal', '.modal', function (event) {
                    var zIndex = 1040 + (10 * $('.modal:visible').length);
                    $(this).css('z-index', zIndex);
                    setTimeout(function() {
                        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                    }, 0);
                });
            });
        },

        methods: {
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    url: that.myurl,
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            that.handleGeneratePayrollButton();
                        });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        var popupProcessButton 	= document.querySelector("#popupProcessButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        
                        function processQueueLocal(){
                            that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                            }
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            var msg = null;
                            if(obj.code == "200") {
                              if(that.myurl == that.$global.base_url+'api/postTopupBulkUpload'){
                               toast.fire({
                                type: 'success',
                                title: 'Batch uploaded successfully'
                                });
                              }
                              else{
                                  toast.fire({
                                type: 'success',
                                title: 'Batch re-uploaded successfully'
                               });

                              }
                            that.$router.push('/topupsPayments');
                            }else if(obj.code == "2"){
                                msg = obj.message;
                            }else if(obj.code == "301"){
                                msg = obj.message;
                            }else{
                                msg = obj.message;
                            }
                            if(msg !== null){
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });
                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                this.fileAdded = false;
                                var error_message = $('div#wrongfilemessage').html();
                                that.showAlertBox('error','Error in file',error_message);
                                this.removeFile(file);
                            }
                            console.log(xhr);
                            if(429 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(428 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(427 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(426 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(425 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(424 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(423 == xhr.status){
                                that.showAlertBox('Error','Error in file',xhr.message);
                            }else if(422 == xhr.status){
                                that.showAlertBox('Error', xhr.statusText);
                            }else if(401 == xhr.status){
                                swal.fire({
                                    title: "Session Expired",
                                    text: "Your session has expired. Would you like to be redirected to the login page?",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "Yes",
                                    closeOnConfirm: false
                                }).then((result) => {
                                    if (result.value) {
                                        window.location = '/login';
                                    }
                                });
                            }else{
                                // var msg = 'Error:'+xhr.status+' '+xhr.statusText;
                                that.showAlertBox('error','Error', "Something went wrong while processing file");
                            }
                        });
                    }
                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },

            handleGeneratePayrollButton(){
                if(this.fileAdded == true){
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },

            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },

            printTable(file) {
                var deptRowid = 0;
                var categoryRowid = 0;
                var cityRowid = 0;
                var branchRowid = 0;
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            if(data[row] != ""){
                                for(var item in data[row]){
                                    var value = data[row][item];
                                    _row.push(value);
                                }
                                that.fileRowData.push(_row);
                            }
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList

                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobile_number = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'network'){
                            that.mand_network = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'amount'){
                            that.mand_amount = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'type'){
                            that.mand_type = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'name'){
                            that.mand_name = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Topup Detail">';
                  
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="mobile number" '+selected+'>Mobile Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'network') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'network') ? true : fieldMap;
                        comboBox += '<option value="network" '+selected+'>Network</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'amount') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'amount') ? true : fieldMap;
                        comboBox += '<option value="amount" '+selected+'>Amount</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'type') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'type') ? true : fieldMap;
                        comboBox += '<option value="type" '+selected+'>Type</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="name" '+selected+'>Name</option>';
                        comboBox += '</optgroup>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName.replace(/^(.)|\s+(.)/g, c => c.toUpperCase())+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },

            generateButtonProccess(){
                if(this.mand_mobile_number == true && this.mand_amount && this.mand_network == true && this.mand_type == true && this.mand_name == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },

            checkForMandField(){
                $( "select.selectpicker" ).each(function() {
                    this.mand_mobile_number = this.mand_amount = this.mand_network = this.mand_type = this.mand_name =false;
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'mobile number') this.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'amount') this.mand_amount = true;
                    if(selVal.trim().toLowerCase() == 'network') this.mand_network = true;
                    if(selVal.trim().toLowerCase() == 'type') this.mand_type = true;
                    if(selVal.trim().toLowerCase() == 'name') this.mand_name = true;
                });
            },

            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);

                    $(this).find('option:selected').parent().parent().parent().parent().parent().parent().addClass('mapped');
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);

                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobile_number = true;
                    if(selVal.trim().toLowerCase() == 'amount') that.mand_amount = true;
                    if(selVal.trim().toLowerCase() == 'network') that.mand_network = true;
                    if(selVal.trim().toLowerCase() == 'type') that.mand_type = true;
                    if(selVal.trim().toLowerCase() == 'name') that.mand_name = true;
                    that.generateButtonProccess();
                });
            },

            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },

            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        var error_message = $('div#duplicatemessage').html() + duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            }

        },
        
    }
</script>